import { render, staticRenderFns } from "./Set_permissions.vue?vue&type=template&id=5328f74a&scoped=true"
import script from "./Set_permissions.vue?vue&type=script&lang=js"
export * from "./Set_permissions.vue?vue&type=script&lang=js"
import style0 from "./Set_permissions.vue?vue&type=style&index=0&id=5328f74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328f74a",
  null
  
)

export default component.exports